import { useMemo } from "react"
import styles from "./GraphNormalRange.module.scss"
import { useGetMgdlAsTopPosition } from "./useGetMgdlAsTopPosition"
import { useFollowedUsers } from "src/contexts"

export function GraphNormalRange() {
  const { currentFollow } = useFollowedUsers()
  const displaySettings = currentFollow.display_settings
  const getMgdlAsTopPosition = useGetMgdlAsTopPosition()

  const [topPosition] = getMgdlAsTopPosition(displaySettings.range_normal_top)
  const [bottomPosition] = getMgdlAsTopPosition(displaySettings.range_normal_bottom)

  const normalRangeStyles = useMemo(
    () => ({
      top: topPosition,
      height: bottomPosition - topPosition,
    }),
    [
      bottomPosition,
      topPosition,
    ],
  )

  return (
    <div
      id="normal-range-line"
      className={styles.normalRange}
      style={normalRangeStyles}
    />
  )
}
